__turbopack_context__.v({
  "author": "_5Oulua_author",
  "carousalContainer": "_5Oulua_carousalContainer",
  "carousalElement": "_5Oulua_carousalElement",
  "circleBlurBtn": "_5Oulua_circleBlurBtn",
  "content": "_5Oulua_content",
  "elementContent": "_5Oulua_elementContent",
  "embla": "_5Oulua_embla",
  "emblaContainer": "_5Oulua_emblaContainer",
  "emblaNext": "_5Oulua_emblaNext",
  "emblaPrev": "_5Oulua_emblaPrev",
  "emblaShimmer": "_5Oulua_emblaShimmer",
  "emblaSlide": "_5Oulua_emblaSlide",
  "emblaSlideSelected": "_5Oulua_emblaSlideSelected",
  "message": "_5Oulua_message",
  "productOverlayButton": "_5Oulua_productOverlayButton",
  "root": "_5Oulua_root" + " " + __turbopack_context__.i(92740)["sectionPadding"],
  "testimonial": "_5Oulua_testimonial",
  "textCarousal": "_5Oulua_textCarousal",
});
